import { render, staticRenderFns } from "./BarApp.vue?vue&type=template&id=ad3d9d5c"
import script from "./BarApp.vue?vue&type=script&lang=ts"
export * from "./BarApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports